import { render, staticRenderFns } from "./transferLogin.vue?vue&type=template&id=9caba608&"
import script from "./transferLogin.vue?vue&type=script&lang=js&"
export * from "./transferLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports